import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Statement = () => {
  const { t } = useLanguage();

  return (
    <section className="py-32 md:py-40 px-6 bg-white">
      <div className="max-w-5xl mx-auto text-center">
        <div className="space-y-6">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-light text-[#2C2C2C] leading-relaxed">
            {t('home.statement.line1')}
          </h2>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-light text-[#2C2C2C] leading-relaxed">
            {t('home.statement.line2')}
          </h2>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-light text-[#2C2C2C] leading-relaxed">
            {t('home.statement.line3')}
          </h2>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-light text-[#5A5A5A] leading-relaxed pt-8">
            {t('home.statement.line4')}
          </h2>
        </div>
      </div>
    </section>
  );
};

export default Statement;
